/* =============================================================
   CHIKI KITOS — Custom JS
   Subir como: assets/chikikitos-custom.js
   Enlazar desde: layout/theme.liquid (al final del <body>)
   Hace: parallax multicapa + copitos de nieve + reveal on scroll
   ============================================================= */
(function(){
  'use strict';

  // ===== Generar copitos de nieve =====
  function makeSnow(){
    var snow = document.querySelector('.ck-snowflakes');
    if (!snow || snow.dataset.ready === '1') return;
    snow.dataset.ready = '1';
    var flakes = ['❄', '❅', '❆', '✦', '·'];
    var total = 30;
    for (var i = 0; i < total; i++){
      var s = document.createElement('span');
      s.textContent = flakes[Math.floor(Math.random() * flakes.length)];
      s.style.left = (Math.random() * 100) + '%';
      s.style.fontSize = (8 + Math.random() * 18) + 'px';
      s.style.animationDuration = (8 + Math.random() * 10) + 's';
      s.style.animationDelay = '-' + (Math.random() * 12) + 's';
      s.style.opacity = (0.4 + Math.random() * 0.6).toString();
      snow.appendChild(s);
    }
  }

  // ===== Parallax multicapa =====
  var ticking = false;
  function parallax(){
    var sc = window.scrollY;
    var vh = window.innerHeight;
    var layers = document.querySelectorAll('[data-ck-speed]');
    layers.forEach(function(el){
      var speed = parseFloat(el.dataset.ckSpeed);
      var rect = el.getBoundingClientRect();
      if (rect.bottom > -200 && rect.top < vh + 200){
        var y = sc * speed;
        el.style.transform = 'translate3d(0, ' + y + 'px, 0)';
      }
    });
    ticking = false;
  }
  window.addEventListener('scroll', function(){
    if (!ticking){
      window.requestAnimationFrame(parallax);
      ticking = true;
    }
  }, { passive: true });

  // ===== Reveal on scroll =====
  function setupReveal(){
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.ck-reveal').forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.ck-reveal').forEach(function(el){ obs.observe(el); });
  }

  // ===== Init =====
  function init(){
    makeSnow();
    parallax();
    setupReveal();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();